import bowser from 'bowser';
import navigationViewport from './navigation--viewport.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock/";

navigationViewport.then(function () {
  const topBar = document.querySelector('.top-bar');
  const navigation = document.querySelector('.main-menu__navigation');
  const navigationSwitch = document.querySelector('.switch-trigger');
  const navigationCheckbox = document.getElementById('switch-navigation');
  let changeEventName = 'change';

  if (bowser.ios || bowser.msedge) { // This is ugly, and I don't know why it doesn't work without it in iOS/Edge
    navigationSwitch.removeAttribute('for');
    navigationSwitch.addEventListener('tap', toggleNavigation);
    changeEventName = 'custom-change';
  }

  function toggleNavigation() {
    navigationCheckbox.checked = !navigationCheckbox.checked;
    navigationCheckbox.dispatchEvent(new CustomEvent(changeEventName));
  }

  function outsideTapListener(event) {
    var event = Polymer.dom(event);
    if (event.path.indexOf(navigation) === -1) {
      resetScrollLock();
      if (event.path.indexOf(navigationSwitch) === -1) {
        navigationCheckbox.checked = false;
      }
    }
  }

  function setScrollLock() {
    document.addEventListener('tap', outsideTapListener, true);
    disableBodyScroll()
  }

  function resetScrollLock() {
    enableBodyScroll()
    document.removeEventListener('tap', outsideTapListener, true);
  }

  function navigationCheckboxListener() {
    navigationCheckbox.checked ? setScrollLock() : resetScrollLock();
  }

  function initScrollDisabler() {
    if (window.fitNavigationViewport === 'mobile') {
      navigationCheckbox && navigationCheckbox.addEventListener(changeEventName, navigationCheckboxListener);
    } else {
      navigationCheckbox && navigationCheckbox.removeEventListener(changeEventName, navigationCheckboxListener);
      navigationCheckbox && (navigationCheckbox.checked = false);
      resetScrollLock();
    }
  }

  if (navigationCheckbox) {
    document.body.addEventListener('navigationChange', initScrollDisabler);
    initScrollDisabler();
  }
});